// Generated by: node scripts/export-surfacing-variants.mjs
// Paste into src/quote/constants.js (variant lookup tables section)

export const PIP_MATERIALS_VARIANTS = [
  { price:    2000, variantId: '41958291701857' },
  { price:    3000, variantId: '41958291734625' },
  { price:    4000, variantId: '41958291767393' },
  { price:    5000, variantId: '41958291800161' },
  { price:    6000, variantId: '41958291832929' },
  { price:    7000, variantId: '41958322798689' },
  { price:    8000, variantId: '41958322929761' },
  { price:    9000, variantId: '41958323028065' },
  { price:   10000, variantId: '41958323093601' },
  { price:   11000, variantId: '41958323126369' },
  { price:   12000, variantId: '41958323159137' },
  { price:   13000, variantId: '41958324306017' },
  { price:   14000, variantId: '41958326206561' },
  { price:   15000, variantId: '41958325485665' },
  { price:   16000, variantId: '41958326239329' },
  { price:   17000, variantId: '41958326272097' },
  { price:   18000, variantId: '41958326468705' },
  { price:   19000, variantId: '41964852215905' },
  { price:   20000, variantId: '41964852248673' },
  { price:   21000, variantId: '41964852281441' },
  { price:   22000, variantId: '41964852314209' },
  { price:   23000, variantId: '41964852346977' },
  { price:   24000, variantId: '41964852379745' },
  { price:   25000, variantId: '41964852412513' },
  { price:   26000, variantId: '41964852445281' },
  { price:   27000, variantId: '41964852478049' },
  { price:   28000, variantId: '41964852510817' },
  { price:   29000, variantId: '41964852543585' },
  { price:   30000, variantId: '41964852576353' },
  { price:   31000, variantId: '41964852609121' },
  { price:   32000, variantId: '41964852641889' },
  { price:   33000, variantId: '41964852674657' },
  { price:   34000, variantId: '41964852707425' },
  { price:   35000, variantId: '41964852740193' },
  { price:   36000, variantId: '41964852772961' },
  { price:   37000, variantId: '41964852805729' },
  { price:   38000, variantId: '41964852838497' },
  { price:   39000, variantId: '41964852871265' },
  { price:   40000, variantId: '41964852904033' },
  { price:   41000, variantId: '41964852936801' },
  { price:   42000, variantId: '41964852969569' },
  { price:   43000, variantId: '41964853002337' },
  { price:   44000, variantId: '41964853035105' },
  { price:   45000, variantId: '41964853067873' },
  { price:   46000, variantId: '41964853100641' },
  { price:   47000, variantId: '41964853133409' },
  { price:   48000, variantId: '41964853166177' },
  { price:   49000, variantId: '41964853198945' },
  { price:   50000, variantId: '41964853231713' },
  { price:   51000, variantId: '41964853264481' },
  { price:   52000, variantId: '41964853297249' },
  { price:   53000, variantId: '41964853330017' },
  { price:   54000, variantId: '41964853362785' },
  { price:   55000, variantId: '41964853395553' },
  { price:   56000, variantId: '41964853428321' },
  { price:   57000, variantId: '41964853461089' },
  { price:   58000, variantId: '41964853493857' },
  { price:   59000, variantId: '41964853526625' },
  { price:   61000, variantId: '41964853559393' },
  { price:   63000, variantId: '41964853592161' },
  { price:   65000, variantId: '41964853624929' },
  { price:   67000, variantId: '41964853657697' },
  { price:   69000, variantId: '41964853690465' },
  { price:   71000, variantId: '41964853723233' },
  { price:   73000, variantId: '41964853756001' },
  { price:   75000, variantId: '41964853788769' },
  { price:   77000, variantId: '41964853821537' },
  { price:   79000, variantId: '41964853854305' },
  { price:   81000, variantId: '41964853887073' },
  { price:   83000, variantId: '41964853919841' },
  { price:   85000, variantId: '41964853952609' },
  { price:   87000, variantId: '41964853985377' },
  { price:   89000, variantId: '41964854018145' },
  { price:   91000, variantId: '41964854050913' },
  { price:   93000, variantId: '41964854083681' },
  { price:   95000, variantId: '41964854116449' },
  { price:   97000, variantId: '41964854149217' },
  { price:   99000, variantId: '41964854181985' },
  { price:  104000, variantId: '41964854214753' },
  { price:  109000, variantId: '41964854247521' },
  { price:  114000, variantId: '41964854280289' },
  { price:  119000, variantId: '41964854313057' },
  { price:  124000, variantId: '41964854345825' },
  { price:  129000, variantId: '41964854378593' },
  { price:  134000, variantId: '41964854411361' },
  { price:  139000, variantId: '41964854444129' },
  { price:  144000, variantId: '41964854476897' },
  { price:  149000, variantId: '41964854509665' },
  { price:  159000, variantId: '41964854542433' },
  { price:  169000, variantId: '41964854575201' },
  { price:  189000, variantId: '41964854607969' },
  { price:  209000, variantId: '41964854640737' },
  { price:  229000, variantId: '41964854673505' },
  { price:  249000, variantId: '41969793302625' },
  { price:  269000, variantId: '41971566608481' },
  { price:  299000, variantId: '41971566641249' },
  { price:  349000, variantId: '41971566674017' },
  { price:  399000, variantId: '41971566706785' },
  { price:  449000, variantId: '41971566739553' },
  { price:  583000, variantId: '42196902215777' },
  { price:  717000, variantId: '42196904575073' },
];
export const PIP_LABOR_VARIANTS = [
  { price:    1000, variantId: '41963888279649' },
  { price:    2000, variantId: '41963888312417' },
  { price:    3000, variantId: '41963888345185' },
  { price:    4000, variantId: '41963888377953' },
  { price:    5000, variantId: '41963888410721' },
  { price:    6000, variantId: '41963888443489' },
  { price:    7000, variantId: '41963888476257' },
  { price:    8000, variantId: '41963888509025' },
  { price:    9000, variantId: '41963888541793' },
  { price:   10000, variantId: '41963888574561' },
  { price:   11000, variantId: '41963888607329' },
  { price:   12000, variantId: '41963888640097' },
  { price:   13000, variantId: '41963888672865' },
  { price:   14000, variantId: '41963888705633' },
  { price:   15000, variantId: '41963888738401' },
  { price:   16000, variantId: '41963888771169' },
  { price:   17000, variantId: '41963888803937' },
  { price:   18000, variantId: '41964855001185' },
  { price:   19000, variantId: '41964855033953' },
  { price:   20000, variantId: '41964855066721' },
  { price:   21000, variantId: '41964855099489' },
  { price:   22000, variantId: '41964855132257' },
  { price:   23000, variantId: '41964855165025' },
  { price:   24000, variantId: '41964855197793' },
  { price:   25000, variantId: '41964855230561' },
  { price:   26000, variantId: '41964855263329' },
  { price:   27000, variantId: '41964855296097' },
  { price:   28000, variantId: '41964855328865' },
  { price:   29000, variantId: '41964855361633' },
  { price:   30000, variantId: '41964855394401' },
  { price:   31000, variantId: '41964855427169' },
  { price:   32000, variantId: '41964855459937' },
  { price:   33000, variantId: '41964855492705' },
  { price:   34000, variantId: '41964855525473' },
  { price:   35000, variantId: '41964855558241' },
  { price:   36000, variantId: '41964855591009' },
  { price:   37000, variantId: '41964855623777' },
  { price:   38000, variantId: '41964855656545' },
  { price:   39000, variantId: '41964855689313' },
  { price:   40000, variantId: '41964855722081' },
  { price:   41000, variantId: '41964855754849' },
  { price:   42000, variantId: '41964855787617' },
  { price:   43000, variantId: '41964855820385' },
  { price:   44000, variantId: '41964855853153' },
  { price:   45000, variantId: '41964855885921' },
  { price:   46000, variantId: '41964855918689' },
  { price:   47000, variantId: '41964855951457' },
  { price:   48000, variantId: '41964855984225' },
  { price:   49000, variantId: '41964856016993' },
  { price:   50000, variantId: '41964856049761' },
  { price:   52000, variantId: '41964856082529' },
  { price:   54000, variantId: '41964856115297' },
  { price:   56000, variantId: '41964856148065' },
  { price:   58000, variantId: '41964856180833' },
  { price:   60000, variantId: '41964856213601' },
  { price:   62000, variantId: '41964856246369' },
  { price:   64000, variantId: '41964856279137' },
  { price:   66000, variantId: '41964856311905' },
  { price:   68000, variantId: '41964856344673' },
  { price:   70000, variantId: '41964856377441' },
  { price:   72000, variantId: '41964856410209' },
  { price:   74000, variantId: '41964856442977' },
  { price:   76000, variantId: '41964856475745' },
  { price:   78000, variantId: '41964856508513' },
  { price:   80000, variantId: '41964856541281' },
  { price:   82000, variantId: '41964856574049' },
  { price:   84000, variantId: '41964856606817' },
  { price:   86000, variantId: '41964856639585' },
  { price:   88000, variantId: '41964856672353' },
  { price:   90000, variantId: '41964856705121' },
  { price:   92000, variantId: '41964856737889' },
  { price:   94000, variantId: '41964856770657' },
  { price:   96000, variantId: '41964856803425' },
  { price:   98000, variantId: '41964856836193' },
  { price:  100000, variantId: '41964856868961' },
  { price:  105000, variantId: '41964856901729' },
  { price:  110000, variantId: '41964856934497' },
  { price:  115000, variantId: '41964856967265' },
  { price:  120000, variantId: '41964857000033' },
  { price:  130000, variantId: '41964857032801' },
  { price:  140000, variantId: '41964857065569' },
  { price:  150000, variantId: '41964857098337' },
  { price:  160000, variantId: '41964857131105' },
  { price:  170000, variantId: '41964857163873' },
  { price:  180000, variantId: '41964857196641' },
  { price:  190000, variantId: '41964857229409' },
  { price:  200000, variantId: '41964857262177' },
  { price:  210000, variantId: '41964857294945' },
  { price:  220000, variantId: '41964857327713' },
  { price:  230000, variantId: '41964857360481' },
  { price:  240000, variantId: '41964857393249' },
  { price:  250000, variantId: '41964857426017' },
  { price:  260000, variantId: '41964857458785' },
  { price:  270000, variantId: '41964857491553' },
  { price:  280000, variantId: '41969804574817' },
  { price:  360000, variantId: '41969808244833' },
  { price:  627500, variantId: '42196906147937' },
];
export const TURF_MATERIALS_VARIANTS = [
  { price:    2000, variantId: '42696113029217' },
  { price:    3000, variantId: '42696113061985' },
  { price:    4000, variantId: '42696113094753' },
  { price:    5000, variantId: '42696113127521' },
  { price:    6000, variantId: '42696113160289' },
  { price:    7000, variantId: '42696113193057' },
  { price:    8000, variantId: '42696113225825' },
  { price:    9000, variantId: '42696113258593' },
  { price:   10000, variantId: '42696113291361' },
  { price:   11000, variantId: '42696113324129' },
  { price:   12000, variantId: '42696113356897' },
  { price:   13000, variantId: '42696113389665' },
  { price:   14000, variantId: '42696113422433' },
  { price:   15000, variantId: '42696113455201' },
  { price:   16000, variantId: '42696113487969' },
  { price:   17000, variantId: '42696113520737' },
  { price:   18000, variantId: '42696113553505' },
  { price:   19000, variantId: '42696113586273' },
  { price:   20000, variantId: '42696113619041' },
  { price:   21000, variantId: '42696113651809' },
  { price:   22000, variantId: '42696113684577' },
  { price:   23000, variantId: '42696113717345' },
  { price:   24000, variantId: '42696113750113' },
  { price:   25000, variantId: '42696113782881' },
  { price:   26000, variantId: '42696113815649' },
  { price:   27000, variantId: '42696113848417' },
  { price:   28000, variantId: '42696113881185' },
  { price:   29000, variantId: '42696113913953' },
  { price:   30000, variantId: '42696113946721' },
  { price:   31000, variantId: '42696113979489' },
  { price:   32000, variantId: '42696114012257' },
  { price:   33000, variantId: '42696114045025' },
  { price:   34000, variantId: '42696114077793' },
  { price:   35000, variantId: '42696114110561' },
  { price:   36000, variantId: '42696114143329' },
  { price:   37000, variantId: '42696114176097' },
  { price:   38000, variantId: '42696114208865' },
  { price:   39000, variantId: '42696114241633' },
  { price:   40000, variantId: '42696114274401' },
  { price:   41000, variantId: '42696114307169' },
  { price:   42000, variantId: '42696114339937' },
  { price:   43000, variantId: '42696114372705' },
  { price:   44000, variantId: '42696114405473' },
  { price:   45000, variantId: '42696114438241' },
  { price:   46000, variantId: '42696114471009' },
  { price:   47000, variantId: '42696114503777' },
  { price:   48000, variantId: '42696114536545' },
  { price:   49000, variantId: '42696114569313' },
  { price:   50000, variantId: '42696114602081' },
  { price:   51000, variantId: '42696114634849' },
  { price:   52000, variantId: '42696114667617' },
  { price:   53000, variantId: '42696114700385' },
  { price:   54000, variantId: '42696114733153' },
  { price:   55000, variantId: '42696114765921' },
  { price:   56000, variantId: '42696114798689' },
  { price:   57000, variantId: '42696114831457' },
  { price:   58000, variantId: '42696114864225' },
  { price:   59000, variantId: '42696114896993' },
  { price:   61000, variantId: '42696114929761' },
  { price:   63000, variantId: '42696114962529' },
  { price:   65000, variantId: '42696114995297' },
  { price:   67000, variantId: '42696115028065' },
  { price:   69000, variantId: '42696115060833' },
  { price:   71000, variantId: '42696115093601' },
  { price:   73000, variantId: '42696115126369' },
  { price:   75000, variantId: '42696115159137' },
  { price:   77000, variantId: '42696115191905' },
  { price:   79000, variantId: '42696115224673' },
  { price:   81000, variantId: '42696115257441' },
  { price:   83000, variantId: '42696115290209' },
  { price:   85000, variantId: '42696115322977' },
  { price:   87000, variantId: '42696115355745' },
  { price:   89000, variantId: '42696115388513' },
  { price:   91000, variantId: '42696115421281' },
  { price:   93000, variantId: '42696115454049' },
  { price:   95000, variantId: '42696115486817' },
  { price:   97000, variantId: '42696115519585' },
  { price:   99000, variantId: '42696115552353' },
  { price:  104000, variantId: '42696115585121' },
  { price:  109000, variantId: '42696115617889' },
  { price:  114000, variantId: '42696115650657' },
  { price:  119000, variantId: '42696115683425' },
  { price:  124000, variantId: '42696115716193' },
  { price:  129000, variantId: '42696115748961' },
  { price:  134000, variantId: '42696115781729' },
  { price:  139000, variantId: '42696115814497' },
  { price:  144000, variantId: '42696115847265' },
  { price:  149000, variantId: '42696115880033' },
  { price:  159000, variantId: '42696115912801' },
  { price:  169000, variantId: '42696115945569' },
  { price:  189000, variantId: '42696115978337' },
  { price:  209000, variantId: '42696116011105' },
  { price:  229000, variantId: '42696116043873' },
  { price:  249000, variantId: '42696116076641' },
  { price:  269000, variantId: '42696116109409' },
  { price:  299000, variantId: '42696116142177' },
  { price:  349000, variantId: '42696116174945' },
  { price:  399000, variantId: '42696116207713' },
  { price:  449000, variantId: '42696116240481' },
  { price:  583000, variantId: '42696116273249' },
  { price:  717000, variantId: '42696116306017' },
];
export const TURF_LABOR_VARIANTS = [
  { price:    1000, variantId: '42696103821409' },
  { price:    2000, variantId: '42696103854177' },
  { price:    3000, variantId: '42696103886945' },
  { price:    4000, variantId: '42696103919713' },
  { price:    5000, variantId: '42696103952481' },
  { price:    6000, variantId: '42696103985249' },
  { price:    7000, variantId: '42696104018017' },
  { price:    8000, variantId: '42696104050785' },
  { price:    9000, variantId: '42696104083553' },
  { price:   10000, variantId: '42696104116321' },
  { price:   11000, variantId: '42696104149089' },
  { price:   12000, variantId: '42696104181857' },
  { price:   13000, variantId: '42696104214625' },
  { price:   14000, variantId: '42696104247393' },
  { price:   15000, variantId: '42696104280161' },
  { price:   16000, variantId: '42696104312929' },
  { price:   17000, variantId: '42696104345697' },
  { price:   18000, variantId: '42696104378465' },
  { price:   19000, variantId: '42696104411233' },
  { price:   20000, variantId: '42696104444001' },
  { price:   21000, variantId: '42696104476769' },
  { price:   22000, variantId: '42696104509537' },
  { price:   23000, variantId: '42696104542305' },
  { price:   24000, variantId: '42696104575073' },
  { price:   25000, variantId: '42696104607841' },
  { price:   26000, variantId: '42696104640609' },
  { price:   27000, variantId: '42696104673377' },
  { price:   28000, variantId: '42696104706145' },
  { price:   29000, variantId: '42696104738913' },
  { price:   30000, variantId: '42696104771681' },
  { price:   31000, variantId: '42696104804449' },
  { price:   32000, variantId: '42696104837217' },
  { price:   33000, variantId: '42696104869985' },
  { price:   34000, variantId: '42696104902753' },
  { price:   35000, variantId: '42696104935521' },
  { price:   36000, variantId: '42696104968289' },
  { price:   37000, variantId: '42696105001057' },
  { price:   38000, variantId: '42696105033825' },
  { price:   39000, variantId: '42696105066593' },
  { price:   40000, variantId: '42696105099361' },
  { price:   41000, variantId: '42696105132129' },
  { price:   42000, variantId: '42696105164897' },
  { price:   43000, variantId: '42696105197665' },
  { price:   44000, variantId: '42696105230433' },
  { price:   45000, variantId: '42696105263201' },
  { price:   46000, variantId: '42696105295969' },
  { price:   47000, variantId: '42696105328737' },
  { price:   48000, variantId: '42696105361505' },
  { price:   49000, variantId: '42696105394273' },
  { price:   50000, variantId: '42696105427041' },
  { price:   52000, variantId: '42696105459809' },
  { price:   54000, variantId: '42696105492577' },
  { price:   56000, variantId: '42696105525345' },
  { price:   58000, variantId: '42696105558113' },
  { price:   60000, variantId: '42696105590881' },
  { price:   62000, variantId: '42696105623649' },
  { price:   64000, variantId: '42696105656417' },
  { price:   66000, variantId: '42696105689185' },
  { price:   68000, variantId: '42696105721953' },
  { price:   70000, variantId: '42696105754721' },
  { price:   72000, variantId: '42696105787489' },
  { price:   74000, variantId: '42696105820257' },
  { price:   76000, variantId: '42696105853025' },
  { price:   78000, variantId: '42696105885793' },
  { price:   80000, variantId: '42696105918561' },
  { price:   82000, variantId: '42696105951329' },
  { price:   84000, variantId: '42696105984097' },
  { price:   86000, variantId: '42696106016865' },
  { price:   88000, variantId: '42696106049633' },
  { price:   90000, variantId: '42696106082401' },
  { price:   92000, variantId: '42696106115169' },
  { price:   94000, variantId: '42696106147937' },
  { price:   96000, variantId: '42696106180705' },
  { price:   98000, variantId: '42696106213473' },
  { price:  100000, variantId: '42696106246241' },
  { price:  105000, variantId: '42696106279009' },
  { price:  110000, variantId: '42696106311777' },
  { price:  115000, variantId: '42696106344545' },
  { price:  120000, variantId: '42696106377313' },
  { price:  130000, variantId: '42696106410081' },
  { price:  140000, variantId: '42696106442849' },
  { price:  150000, variantId: '42696106475617' },
  { price:  160000, variantId: '42696106508385' },
  { price:  170000, variantId: '42696106541153' },
  { price:  180000, variantId: '42696106573921' },
  { price:  190000, variantId: '42696106606689' },
  { price:  200000, variantId: '42696106639457' },
  { price:  210000, variantId: '42696106672225' },
  { price:  220000, variantId: '42696106704993' },
  { price:  230000, variantId: '42696106737761' },
  { price:  240000, variantId: '42696106770529' },
  { price:  250000, variantId: '42696106803297' },
  { price:  260000, variantId: '42696106836065' },
  { price:  270000, variantId: '42696106868833' },
  { price:  280000, variantId: '42696106901601' },
  { price:  360000, variantId: '42696106934369' },
  { price:  627500, variantId: '42696106967137' },
  { price:  827500, variantId: '42701246169185' },
];
